module.exports = __webpack_public_path__ + "img/education.564a2e6b.png";